import React, { useEffect } from 'react'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { useLocation } from 'react-router-dom'

if (typeof window !== 'undefined' && process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: 'https://eu.i.posthog.com',
    person_profiles: 'always',
    capture_pageview: false,
    opt_out_capturing_by_default: true,
  })
}
export function PostHogOptIn(): void {
  posthog.opt_in_capturing()
}

export function PostHogOptOut(): void {
  posthog.opt_out_capturing()
}
export function PostHogProv({
  children,
}: {
  children: React.ReactNode
}): React.JSX.Element {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}

export function PostHogPageView(): null {
  const location = useLocation()

  // Track pageviews
  useEffect(() => {
    if (posthog) {
      posthog.capture('$pageview', {
        $current_url: window.location.href,
      })
    }
  }, [location])

  return null
}
